import { shiphawkAccionesRoles } from '../../acciones-roles/shipHawk/shiphawk-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton1,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const sidebarShipHawkData: SideBarButton[] = [
  {
    data: {
      name: 'Generar excel',
    },
    options: PreConfigButton1,
    icon: 'task',
    butons: [
      {
        data: {
          name: 'Generar excel',
          url: '/shiphawk/generate-excel',
          roles: shiphawkAccionesRoles.sideNavActions.shiphawkGenerateExcel,
        },
        options: PreConfigButton3,
      },
    ],
  },
];
